import { render, staticRenderFns } from "./DeletePartDialog.vue?vue&type=template&id=55b1b034&"
import script from "./DeletePartDialog.vue?vue&type=script&lang=js&"
export * from "./DeletePartDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DeletePartDialog.vue"
export default component.exports